export default __webpack_public_path__ + "static/DanHocking-BookingInformation-e920015fe7977fa93aa0205dffd656f0.pdf";